import { createSlice, createAction } from "@reduxjs/toolkit";

export const initialState = {
  clientsWithFailingNotifications: [],
};

export const slice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setClientsWithFailingNotifications: (state, action) => {
      state.clientsWithFailingNotifications = action.payload;
    },
  },
});

export const { setClientsWithFailingNotifications } = slice.actions;

export const startNotificationsPolling = createAction(
  "startNotificationsPolling"
);
export const stopNotificationsPolling = createAction(
  "stopNotificationsPolling"
);

export const selectClientsWithFailingNotifications = (state: any) =>
  state.notifications.clientsWithFailingNotifications;

export default slice.reducer;
